module.exports = __webpack_public_path__ + "static/img/header-mobile.54a1b31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header-mobile.jpg
// module id = vrT9
// module chunks = 1